import { useState } from 'react'

import StyledDateTimePicker from '../../../styles/styledComponents/styledDateTimePicker'
import FieldLabel from './fieldLabel'

interface FormDateTimePickerProps {
    title: string
    date: Date | null
    changeHandler: (newDateTime: unknown) => void
    isOpen?: boolean
    handleOpen?: () => void
    disabledCondition?: boolean
    error?: boolean
    fieldRequired?: boolean
}

const FormDateTimePicker = ({
    changeHandler,
    date,
    title,
    disabledCondition,
    error,
    fieldRequired,
}: FormDateTimePickerProps) => {
    const [open, setOpen] = useState(false)
    const handleOpen = () => {
        if (!disabledCondition) {
            setOpen(!open)
        }
        return
    }

    return (
        <>
            <FieldLabel required={fieldRequired}>{title}</FieldLabel>
            <StyledDateTimePicker
                data-test="date-time-picker"
                value={date}
                onChange={changeHandler}
                timezone="UTC"
                open={open}
                disableOpenPicker={disabledCondition}
                disabled={disabledCondition}
                onAccept={() => setOpen(false)}
                slotProps={{
                    desktopPaper: {
                        sx: { svg: { color: '#08294e' }, span: { color: '#08294e' } },
                    },
                    textField: {
                        fullWidth: true,
                        id: 'date-time-input',
                        InputLabelProps: { shrink: false },
                        onClick: () => handleOpen(),
                        error: error,
                    },
                }}
            />
        </>
    )
}

export default FormDateTimePicker
